// src/components/common/CloseButton.jsx
export default function CloseButton({ onClick, title = "Закрити" }) {
  return (
    <button
      type="button"
      aria-label={title}
      title={`${title} (Esc)`}
      onClick={onClick}
      style={{
        width: 32,
        height: 32,
        borderRadius: 999,
        border: "1px solid #e5e7eb",
        background: "#3e51c1",
        display: "inline-flex",
        fontSize: "17px",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
    >
      {/* X icon (SVG) */}X
    </button>
  );
}
